import template from './report_time_logged_help.html';
import * as Utils from '../../lib/savanna_utils.js';

class ReportTimeHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class ReportTimeHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new ReportTimeHelpViewModel(this);
		this.bindings = bindings;
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'ReportTimeLoggedHelp',
	dialog_class: ReportTimeHelpPage,
	template: template,
	template_filename: 'translation/dialogs/report_time_logged_help',
	provider: 'ps'
};
